export default __webpack_public_path__ + "images/5f4694ba3657b4c8afee1063dcc483ee-agent.png";